"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataSecurityDetectedApplicationById = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getDataSecurityDetectedApplicationById = (0, sonar_http_1.createGetEndpoint)(({ applicationId }) => `/api/v3/data-security/applications/${applicationId}/detected-application-card`);
//# sourceMappingURL=getDataSecurityDetectedApplicationById.js.map